angular.module('mercury.modules.thirdparty', [
'mercury.modules.thirdparty.survicate',
'mercury.modules.thirdparty.intercom'
]);
